/**
 * creator:
 * date: 2021-1-19 15:46:44
 * path:
 * description:
 * @link:
 */
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Loadable from 'react-loadable';
import { Loading } from 'components';

const Spin = () => <Loading loading />;

const Main = Loadable({
	loader: () => import('./main.js'),
	loading: Spin,
});

const JobDetail = Loadable({
	loader: () => import('./routes/detail'),
	loading: Spin,
});

const JobEdit = Loadable({
	loader: () => import('./routes/edit'),
	loading: Spin,
});

export default ({ match }) => {
	return (
		<Switch>
			<Route path={`${match.url}/edit`} component={JobEdit} />
			<Route path={`${match.url}/detail/:id`} component={JobDetail} />
			<Route path={`${match.url}/add`} component={JobEdit} />
			<Route path= {match.url} component={Main} />
		</Switch>
	);
};
